/**
 * What a check form shows when its register lists nothing: either the register
 * has never loaded on this device (offline), or no units are registered yet.
 */
export function RegisterEmptyState({
  isRegisterUnavailable,
  emptyMessage,
}: {
  isRegisterUnavailable: boolean;
  emptyMessage: string;
}) {
  return (
    <div className="flex w-full flex-col items-start gap-2 rounded-md border border-neutral-200 p-6">
      <span className="text-body font-body text-default-font">
        {isRegisterUnavailable
          ? "Connect once to load the register."
          : emptyMessage}
      </span>
    </div>
  );
}
